import axios from "axios";
import jquery from 'jquery';
window.jQuery = window.$ = jquery;

Init();

$(function () {
   
    //view_item_list per elenco prodotti pagine interne
    var viewItemListElements = GetViewItemListElements();
    if (viewItemListElements && viewItemListElements.length > 0) {
        view_item_list(viewItemListElements);
    }

});

//#region Init
function Init() {
    //console.log(`datalayer init: ${new Date().toISOString()}`);

    axios({
        method: 'get',
        url: `${window.baseurl}/api/DataLayer/Init`,
        params: {}
    })
    .then(response => {
        var initDataLayer = response.data;
        if (initDataLayer) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "init",
                logged_in: initDataLayer.logged_in,
                userData: initDataLayer.userData
            });
        }
        else {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({event: "init", logged_in: false });
        }
    })
    .catch(error => {
        console.log('error:' + error);
    })
}
//#endregion

//#region view_item_list
function GetViewItemListElements() {
    var retval = [];

    var layout3 = FindViewItemListElements("layout-3");
    if (layout3 && layout3.length > 0) { retval.push(layout3); }

    var layout12 = FindViewItemListElements("layout-12");
    if (layout12 && layout12.length > 0) { retval.push(layout12); }

    if (retval && retval.length > 0) {
        retval = retval.reduce(function (prev, next) {
            return prev.concat(next);
        });
    }

    return retval;
}

function FindViewItemListElements(fatherid) {

    var retval = [];
    var father = $(`[id*=${fatherid}]`);
    if (father) {
        for (var i = 0; i < father.length; i++) {
            var element = $(father[i]);
            if (element && element[0]) {
                var title = element.data("title");
                var ids = [];

                //Selector ids
                var subElements = element[0].querySelectorAll('.product');
                if (subElements) {
                    for (var q = 0; q < subElements.length; q++) {
                        var id = $(subElements[q]).data("id");
                        if (id) { ids.push(id); }
                    }

                    if (title && (ids && ids.length > 0)) {

                        var item = {
                            title: title,
                            ids: ids
                        };

                        retval.push(item);
                    }
                }
            }
        }
    }

    return retval;
}

function view_item_list(array) {

    //array[0] = { title: 'test', ids: ['001', '002']}
    console.log('datalayer view_item_list');
    var maxElementViewItemList = 12;

    if (array) {
        for (var q = 0; q < array.length; q++) {
            var items = array[q];
            if (items && items.ids.length > 0) {
                //console.log('DEBUG: ' + JSON.stringify(items))
                var pageNumber = Math.ceil(items.ids.length / maxElementViewItemList);
                for (var i = 1; i <= pageNumber; i++) {
                    var pagedItems = items.ids.slice(((i - 1) * maxElementViewItemList), (i * maxElementViewItemList));

                    axios({
                        method: 'get',
                        url: `${window.baseurl}/api/DataLayer/ViewItemList?IDs=${pagedItems.join(',')}&culture=${window.culture}&name=${items.title}`
                    })
                    .then(response => {
                        var viewDataLayer = response.data;
                        if (viewDataLayer) {
                            dataLayer.push({
                                event: "view_item_list",
                                ecommerce: {
                                    items: viewDataLayer.items
                                }
                            });
                        }
                    })
                    .catch(error => {
                        console.log('error:' + error);
                    })
                }
            }
        }
    }
}
//#endregion

//#region select_item
$(function () {

    $(".select_item_event").click(function () {
        console.log('datalayer select_item');

        var id = $(this).data("id");
        var nameViewItemList = ($("[id*=DataLayerViewItemListPath]").length > 0) ? $("[id*=DataLayerViewItemListPath]").val() : $(this).data("title");
        WriteTrackProductOrgin(id, nameViewItemList);

        if (id) {
            axios({
                method: 'get',
                url: `${window.baseurl}/api/DataLayer/SelectItem?ID=${id}&culture=${window.culture}&name=${nameViewItemList}`
            })
            .then(response => {
                //console.log(response.data.items)
                var viewDataLayer = response.data;
                if (viewDataLayer) {
                    dataLayer.push({
                        event: "select_item",
                        ecommerce: {
                            items: viewDataLayer.items
                        }
                    });
                }
            })
            .catch(error => {
                console.log('error:' + error);
            })
        }
    });

});
//#endregion

//#region faq
$(function () {
    BindFaqEvent();
});

function BindFaqEvent() {

    var eventElements = [];
    var faqElements = $("[id*=flush-collapse");
    for (var i = 0; i < faqElements.length; i++) {
        eventElements.push(faqElements[i].id);
    }
    //console.log(eventElements);

    if (faqElements && faqElements.length > 0) {
        for (var q = 0; q < eventElements.length; q++) {
            var el = document.getElementById(eventElements[q]);
            if (el) {
                el.addEventListener("show.bs.collapse", function () {
                    var title = $(this).data("title");
                    FaqEventDataLayer("open", title);
                });

                el.addEventListener("hide.bs.collapse", function () {
                    var title = $(this).data("title");
                    FaqEventDataLayer("close", title);
                });
            }
        }
    }
}

function FaqEventDataLayer(type, title) {

    console.log('datalayer faq');

    window.dataLayer.push({
        event: "faq",
        faq_action: type,
        faq_name: title
    });
}
//#endregion

//#region calcola_resa
$(function () {
    $("[id*=btnresacalcolata]").on("click", function () {
        console.log('datalayer calcola_resa');

        window.dataLayer.push({
            event: "calcola_resa",
            category: $("[id*=valoreSelezionato]").text(),
            action: $("[id*=valoreInserito]").val(),
            label: $("[id*=valuereplaced]").text()
        });

    });
});
//#endregion

//#region Utils: Write Track Product Origin
function WriteTrackProductOrgin(_id, _value) {

    const sStorageVarKey = "HDG.DataLayer.ProductOrigin";

    //Controllo se non ho la key nel session storage la creo al volo con un json vuoto
    var sStorageValue = sessionStorage.getItem(sStorageVarKey);
    if (!sStorageValue) { sessionStorage.setItem(sStorageVarKey, " [ ] ") }

    var sStorageJSONValue = JSON.parse(sessionStorage.getItem(sStorageVarKey));

    //Controllo se nel mio JSON ho già un item con lo stesso id, se presente lo sostituisco
    if (sStorageJSONValue.length > 0) {

        var foundIndex = sStorageJSONValue.findIndex(x => x.id == _id);
        if (foundIndex == -1) {
            //Elemento non trovato, aggiungo
            sStorageJSONValue.push({ id: _id, value: _value });
        }
        else {
            //Update valore
            sStorageJSONValue[foundIndex].value = _value;
        }
    }
    else {
        //Oggetto vuoto
        sStorageJSONValue.push({ id: _id, value: _value });
    }

    //Update
    sessionStorage.setItem(sStorageVarKey, JSON.stringify(sStorageJSONValue));
}
//#endregion